module.exports = __webpack_public_path__ + "img/bar-code-ac.ae33f185.svg";